<template>
  <div class="fSize">
    <!--去用户绑定页面-->
    <van-action-sheet safe-area-inset-bottom :round="false" v-model="showUserAdd" title="体检用户绑定"
                      :close-on-click-overlay="false" @click-overlay="tipsFun">
      <UserAdd @fatherMethod="closeFun"></UserAdd>
    </van-action-sheet>
    <van-calendar
    @confirm="chooseTime"
    :min-date="minDate" :max-date="maxDate"
  :poppable="false"
  :style="{ height: '480px' }" 
  :show-confirm="false"
  class="newCalendar"
  color="#1989fa"
  :show-subtitle="false"
  title="预约日期选择"
  :formatter="formatter"
/>
    <van-calendar v-model="show" @confirm="chooseTime" :min-date="minDate" :max-date="maxDate" :poppable="true" 
                  :show-confirm="false" class="newCalendar" row-height="1.4rem"
                  :show-subtitle="false" title="预约日期选择" :formatter="formatter" color="#1989fa"/>
    <!--<van-cell title-class="newTitle" title="预约时间" :value="submitData.preDate" is-link/>-->
    <!--<van-field v-model="submitData.preContent" rows="5" autosize type="textarea"
    maxlength="200" placeholder="请输入预约内容，必填200字以内"/>-->
    <van-field name="radio" label="时段选择" label-width="1.2rem" class="newCalendar">
      <template #input>
        <van-radio-group v-model="submitData.prePeriod" direction="horizontal">
          <van-radio :disabled="all_day" class="newRadio" name="all_day" shape="round">全天</van-radio>
          <van-radio :disabled="morning" class="newRadio" name="morning" shape="round">上午</van-radio>
          <van-radio :disabled="afternoon" class="newRadio" name="afternoon" shape="round">下午</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field name="type" label="预约类型" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="columnsText[submitData.type]" placeholder="请点击选择预约类型" @click="showPicker = true"/>
    <van-field required name="radio" label="预约人性别" label-width="1.2rem" class="newCalendar">
      <template #input>
        <van-radio-group v-model="submitData.userSex" direction="horizontal">
          <van-radio name="1">男性</van-radio>
          <van-radio name="0">女性</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <!-- <van-field name="userAge" label="预约人年龄" label-width="1.2rem" class="newCalendar"
               v-model="submitData.userAge" placeholder="请输入用户年龄" type="digit"/> -->
    <van-field required name="phoneNumber" label="手机号码" label-width="1.2rem" class="newCalendar"
               v-model="submitData.phoneNumber" placeholder="请输入手机号码" type="tel" :class="submitData.type!=='health_cert'?'display1':''"/>
    <van-field required name="company" label="单位名称" label-width="1.2rem" class="newCalendar"
               v-model="submitData.company" placeholder="请输入单位名称" :class="submitData.type!=='health_cert'?'display1':''" />
    <van-field required name="companyNature" label="单位性质" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="submitData.companyNature" placeholder="请点击选择单位性质" :class="submitData.type!=='health_cert'?'display1':''" @click="showPicker1 = true"/>
    <!-- <van-field required name="workPlace" label="从业地点" label-width="1.2rem" class="newCalendar"
               v-model="submitData.workPlace" placeholder="请输入从业地点" :class="submitData.type!=='health_cert'?'display1':''"/> -->
    <van-field required name="workPlace" label="从业地点" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="submitData.workPlace" placeholder="请点击选择从业地点" :class="submitData.type!=='health_cert'?'display1':''" @click="showPicker6 = true"/>
    <!-- <van-field name="educationDegree" label="文化程度" label-width="1.2rem" class="newCalendar"
               v-model="submitData.educationDegree" placeholder="预约类型为健康证时必填" :class="submitData.type!=='health_cert'?'display1':''"/> -->
    <van-field required name="educationDegree" label="文化程度" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="submitData.educationDegree" placeholder="请点击选择文化程度" :class="submitData.type!=='health_cert'?'display1':''" @click="showPicker2 = true"/>
    <!-- <van-field name="nation" label="民  族" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="submitData.nation" placeholder="请点击选择民族" :class="submitData.type!=='health_cert'?'display1':''" @click="showPicker5 = true"/>            -->
    <!-- <van-field name="workType" label="工  种" label-width="1.2rem" class="newCalendar"
               v-model="submitData.workType" placeholder="预约类型为健康证时必填"  :class="submitData.type!=='health_cert'?'display1':''"/> -->
    <van-field required name="workType" label="工  种" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="submitData.workType" placeholder="请点击选择工种" :class="submitData.type!=='health_cert'?'display1':''" @click="showPicker3 = true"/>
    <!-- <van-field name="workAge" label="工  龄" label-width="1.2rem" class="newCalendar"
               v-model="submitData.workAge" placeholder="预约类型为健康证时必填" type="digit" :class="submitData.type!=='health_cert'?'display1':''"/> -->
    <van-field required name="workAge" label="工  龄" label-width="1.2rem" class="newCalendar" readonly clickable
               :value="submitData.workAge" placeholder="请点击选择工龄" :class="submitData.type!=='health_cert'?'display1':''" @click="showPicker4 = true"/>
    <van-field name="stepper" label="人数确定" label-width="1.2rem" class="newCalendar marBottom">
      <template #input>
        <van-stepper v-model="submitData.preCount" integer :max="submitData.type==='health_cert'?'1':'5'" />
      </template>
    </van-field>
    <van-cell class="buttonFixed" safe-area-inset-bottom>
      <van-button size="normal" :loading="buttonLoading" loading-text="提交中..." round block type="info"
                  @click="submitFun">提交
      </van-button>
    </van-cell>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom">
      <van-picker show-toolbar :columns="columns1" @confirm="onConfirm1" @cancel="showPicker1 = false"/>
    </van-popup>
    <van-popup v-model="showPicker2" position="bottom">
      <van-picker show-toolbar :columns="columns2" @confirm="onConfirm2" @cancel="showPicker2 = false"/>
    </van-popup>
    <van-popup v-model="showPicker3" position="bottom">
      <van-picker show-toolbar :columns="columns3" @confirm="onConfirm3" @cancel="showPicker3 = false"/>
    </van-popup>
    <van-popup v-model="showPicker4" position="bottom">
      <van-picker show-toolbar :columns="columns4" @confirm="onConfirm4" @cancel="showPicker4 = false"/>
    </van-popup>
    <van-popup v-model="showPicker5" position="bottom">
      <van-picker show-toolbar :columns="columns5" @confirm="onConfirm5" @cancel="showPicker5 = false"/>
    </van-popup>
    <van-popup v-model="showPicker6" position="bottom">
      <van-picker show-toolbar :columns="columns6" @confirm="onConfirm6" @cancel="showPicker6 = false"/>
    </van-popup>
  </div>
</template>

<script>
import {addAppiontment, getCanDate, getPreMessage} from "@/api/common";
import {Cell, RadioGroup, Radio, Field, Button, Toast, Stepper, Calendar, Popup, Picker,ActionSheet} from "vant";
import {Dialog} from "vant";
import UserAdd from '@/components/UserAdd';

export default {
  components: {
    [Cell.name]: Cell, [Radio.name]: Radio, [Field.name]: Field, [Button.name]: Button, [Toast.name]: Toast,
    [Stepper.name]: Stepper, [Calendar.name]: Calendar, [RadioGroup.name]: RadioGroup, [Popup.name]: Popup,
    [Picker.name]: Picker,[ActionSheet.name]: ActionSheet,[Dialog.name]: Dialog, UserAdd
  },
  data() {
    return {
      date: '',
      show: false,
      preDate: null,
      // 最小值为明天，最大大值为30天后
      minDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000 ),
      maxDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000 ),
      submitData: {
        preDate: null,
        userSex: null,
        userAge: null,
        preCount: 1,
        prePeriod: null,
        type: 'health_cert',
        company: null
      },
      buttonLoading: false,
      // 可预约列表
      canDateList: [],
      all_day: false,
      morning: false,
      afternoon: false,
      //----
      columns: [{text: "从业体检", value: "health_cert"}, {text: "职业病", value: "occup_dis"}],
      // columns: [{text: "个人", value: "personal"}, {text: "团检", value: "group"},
      //   {text: "从业体检", value: "health_cert"}, {text: "职业病", value: "occup_dis"},
      // ],
      columnsText: {"health_cert": "从业体检", "occup_dis": "职业病"},
            // columnsText: {"personal": "个人", "group": "团检", "health_cert": "从业体检", "occup_dis": "职业病"},
      columns1: ['全民', '集体', '三资，个体', '国企', '社会组织机构'],
      columns2: ['研究生', '大学本科', '大学专科', '中专', '中技', '高中', '初中', '小学', '半文盲', '文盲'],
      columns3: ['厨师', '美发师', '美容师', '洗碗工', '其他服务人员'],
      columns4: ['<1年', '1年', '2年', '3年', '4年','>=5年'],
      columns5: ['汉族', '蒙古族', '回族', '藏族', '满族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '朝鲜族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
      columns6: ['敖勒召其镇', '上海庙镇', '城川镇', '昂素镇'],
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      showPicker6: false,
      isDisplay:false,
      count: null,
      countUsed: null,
      showUserAdd: false
    };
  },
  created() {
    const that = this;
    if (sessionStorage.getItem("userIsBang") !== 'yes') {
      Toast("请先绑定用户信息...");
      //如果用户信息为空则去设置用户
      that.showUserAdd = true;
      return false;
    }
    
    // 获取预约提示信息
    var param = {};
    getPreMessage(param).then(resp => {
      if (resp.code === 200) {
        Dialog.alert({
          title: '预约提醒',
          message: resp.data,
          messageAlign: 'left'
        }).then(() => {
          // on close
        });
      }
    }).catch(err => {
      console.log(err);
    });

    // 获取可预约列表
    that.getCanDateList();
  },
  mounted() {
    var _this = this;
    window.history.pushState(null, null, "#");
    window.addEventListener(
        "popstate",
        _this.closePage,
        false
    );
  },
  methods: {
    //时间格式化
    formatTime(date, split = '-') {
      let year = date.getFullYear();
      let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      //let hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      //let minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
      //let second = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
      //return year + "-" + month + "-" + day + " " + hour + ":" + minute;
      //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      return year + split + month + split + day;
    },
    //日期插件格式化
    formatter(currentDate) {
      const that = this;
      let tDate = parseInt(that.formatTime(currentDate.date, ""));
      let dDate = parseInt(that.formatTime(new Date(), ""));
      /*if (tDate < parseInt(that.formatTime(that.minDate, "")) || tDate > parseInt(that.formatTime(that.maxDate, "")) || currentDate.date.getDay() === 0 || currentDate.date.getDay() === 6) {
          return currentDate;
      }*/
      // if (tDate === dDate) {
      //   currentDate.bottomInfo = "不可约";
      // }
      if (tDate < parseInt(that.formatTime(that.minDate, "")) || tDate > parseInt(that.formatTime(that.maxDate, ""))) {
        return currentDate;
      }
      currentDate.bottomInfo = "不可约";
      currentDate.type = "disabled";
      for (let i = 0; i < that.canDateList.length; i++) {
        that.count = that.canDateList[i].preCount;
        that.countUsed = that.canDateList[i].preCountUsed;
        let countFlag = false;
        if ((that.count != null && that.countUsed != null && that.count > that.countUsed) || (that.count != null && that.countUsed == null && that.count > 0)) {
            countFlag = true;
        }
        if (parseInt(that.canDateList[i].date) === tDate && countFlag && (new Date().getHours() > 8 && new Date().getHours() < 24)) {
          currentDate.bottomInfo = "可约";
          //selected、start、middle、end、disabled
          currentDate.type = "";
          if (!that.submitData.preDate) {
            let time = that.canDateList[i].date;
            that.submitData.preDate = time.substring(0, 4) + "-" + time.substring(4, 6) + "-" + time.substring(6);
          }
          if (parseInt(that.submitData.preDate.replace(/-/g, "")) === tDate) {
            currentDate.type = "selected";
            that.submitData.preDate = that.formatTime(currentDate.date);
            that.submitData.prePeriod = "morning";
            that.morning = false;
            that.afternoon = false;
            that.all_day = false;
            if (that.canDateList[i].period === "morning") {
              that.morning = false;
              that.afternoon = true;
              that.all_day = true;
            }
            if (that.canDateList[i].period === "afternoon") {
              that.morning = true;
              that.afternoon = false;
              that.all_day = true;
              that.submitData.prePeriod = "afternoon";
            }
            if (that.canDateList[i].period === "all_day") {
              that.morning = true;
              that.afternoon = true;
              that.all_day = false;
              that.submitData.prePeriod = "all_day";
            }
          }
          break;
        }
      }
      return currentDate;
    },
    //获取可预约日期数据
    async getCanDateList() {
      const that = this;
      let res = await getCanDate();
      that.canDateList = res.data;
      /*res.data.forEach(day => {
          day.date = day.date.substring(0, 4) + "-" + day.date.substring(4, 6) + "-" + day.date.substring(6);
      });*/
    },
    //预约时间选择
    chooseTime(date) {
      const that = this;
      that.submitData.preDate = that.formatTime(date);
      for (let i = 0; i < that.canDateList.length; i++) {
        if (parseInt(that.canDateList[i].date) === parseInt(that.submitData.preDate.replace(/-/g, ""))) {
          that.submitData.prePeriod = "morning";
          that.morning = false;
          that.afternoon = false;
          that.all_day = false;
          if (that.canDateList[i].period === "morning") {
            that.morning = false;
            that.afternoon = true;
            that.all_day = true;
          }
          if (that.canDateList[i].period === "afternoon") {
            that.morning = true;
            that.afternoon = false;
            that.all_day = true;
            that.submitData.prePeriod = "afternoon";
          }
          if (that.canDateList[i].period === "all_day") {
            that.morning = true;
            that.afternoon = true;
            that.all_day = false;
            that.submitData.prePeriod = "all_day";
          }
          break;
        }
      }
    },
    closePage() {
      WeixinJSBridge.call("closeWindow");
    },
    //预约信息提交
    submitFun() {
      const that = this;
      // if (sessionStorage.getItem("userIsBang") !== 'yes') {
      //   Toast("请先绑定用户信息...");
      //   //如果用户信息为空则去设置用户
      //   that.showUserAdd = true;
      //   return false;
      // }
      //这里进行数据校验
      if (that.submitData.preDate == null || that.submitData.preDate === "") {
        Toast("【预约时间】不能为空，请选择");
        return false;
      }
      //------
      if (that.submitData.userSex == null) {
        Toast("【预约人性别】不能为空，请填写");
        return false;
      }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.phoneNumber == null || that.submitData.phoneNumber === "")) {
        Toast("【手机号码】不能为空，请填写");
        return false;
      }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.company == null || that.submitData.company === "")) {
        Toast("【单位名称】不能为空，请填写");
        return false;
      }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.companyNature == null || that.submitData.companyNature === "")) {
        Toast("【单位性质】不能为空，请填写");
        return false;
      }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.workPlace == null || that.submitData.workPlace === "")) {
        Toast("【从业地点】不能为空，请填写");
        return false;
      }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.educationDegree == null || that.submitData.educationDegree === "")) {
        Toast("【文化程度】不能为空，请填写");
        return false;
      }
      // if (that.submitData.type !== null && that.submitData.type === "health_cert" && !that.submitData.nation) {
      //   Toast("【民  族】不能为空，请填写");
      //   return false;
      // }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.workType == null || that.submitData.workType === "")) {
        Toast("【工  种】不能为空，请填写");
        return false;
      }
      if (that.submitData.type !== null && that.submitData.type === "health_cert" && (that.submitData.workAge == null || that.submitData.workAge === "")) {
        Toast("【工  龄】不能为空，请填写");
        return false;
      }
      if (that.count != null && that.countUsed != null && that.count > that.countUsed && that.submitData.preCount > (that.count -that.countUsed)) {
        Toast("【预约人数】超过可约人数，可约人数为 " + (that.count -that.countUsed));
        return false;
      } 
      if (that.count != null && that.countUsed == null && that.count > 0 && that.submitData.preCount > that.count) {
        Toast("【预约人数】超过可约人数，可约人数为 " + that.count);
        return false;
      }
      //深度拷贝,数据组装
      let data = JSON.parse(JSON.stringify(that.submitData));
      data.openId = sessionStorage.getItem("openid");
      //按钮相关操作
      that.buttonLoading = true;
      //请求方法
      addAppiontment(data).then(resp => {
        that.buttonLoading = false;
        if (resp.code === 200) {
          that.showK = false;
          Toast({
            type: "success",
            forbidClick: true,
            message: "预约成功..."
          });
          setTimeout(function () {
            window.removeEventListener(
                "popstate",
                that.closePage
            );
            that.$router.push({path: "/appointment"});
          }, 3000);
        } else {
          Toast({
            type: "fail",
            message: resp.msg
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //----------
    // 确认预约类型
    onConfirm(value) {
      const that = this;
      that.submitData.type = value.value;
      that.showPicker = false;
    },
    // 确认单位性质
    onConfirm1(value) {
      const that = this;
      that.submitData.companyNature = value;
      that.showPicker1 = false;
    },
    // 确认文化程度
    onConfirm2(value) {
      const that = this;
      that.submitData.educationDegree = value;
      that.showPicker2 = false;
    },
    // 确认工种
    onConfirm3(value) {
      const that = this;
      that.submitData.workType = value;
      that.showPicker3 = false;
    },
    // 确认工龄
    onConfirm4(value) {
      const that = this;
      that.submitData.workAge = value;
      that.showPicker4 = false;
    },
    // 确认民族
    onConfirm5(value) {
      const that = this;
      that.submitData.nation = value;
      that.showPicker5 = false;
    },
    // 确认从业地点
    onConfirm6(value) {
      const that = this;
      that.submitData.workPlace = value;
      that.showPicker6 = false;
    },
    //关闭添加框组件
    closeFun() {
      const that = this;
      that.showUserAdd = false;
    },
    //判断是否绑定
    tipsFun() {
      if (sessionStorage.getItem("userIsBang") !== 'yes') {
        Toast("请先绑定用户信息...")
      }
    }
  }
};
</script>

<style scoped lang="scss">
.newCalendar {
  --calendar-height: 500px;
  margin: 0.1rem;
  width: initial;
  border-radius: 0.1rem;
  box-shadow: darkgray 0 0 0.1rem;
  font-size: 0.28rem;

  .newRadio {
    // width: 2.25rem;
    font-size: 0.28rem;
    margin-bottom: 0.1rem;
  }
}

.marBottom {
  margin-bottom: 1.32rem;
}
</style>
<style>
.van-calendar__day .van-calendar__bottom-info {
  color: #52c41a;
}

.van-calendar__day--disabled .van-calendar__bottom-info {
  color: red;
}

.van-calendar__day {
  height: 1.2rem !important;
}

.display1 {
  display:none;
}

.van-dialog__message {
	font-size:18px;
}
</style>
